/**
 * Functions to convert between FieldValue JSON formats
 */

/**
 * Field Value Avro type definitions
 */

/**
 * Represents any type of FieldValue in the Avro format
 */

/**
 * Converts from plain JSON format to the FieldValue Avro format
 */
export function convertJsonToFieldValueAvro(jsonValue) {
  if (jsonValue === null || jsonValue === undefined) {
    return {
      __typename: 'com.hubspot.chirp.ext.models.NullFieldValue'
    };
  }
  const type = typeof jsonValue;
  if (type === 'string') {
    return {
      __typename: 'com.hubspot.chirp.ext.models.StringFieldValue',
      value: jsonValue
    };
  }
  if (type === 'number') {
    // Determine if the number is an integer or floating point
    if (Number.isInteger(jsonValue) && jsonValue <= 2147483647 && jsonValue >= -2147483648) {
      return {
        __typename: 'com.hubspot.chirp.ext.models.IntFieldValue',
        value: jsonValue
      };
    } else if (Number.isInteger(jsonValue)) {
      return {
        __typename: 'com.hubspot.chirp.ext.models.LongFieldValue',
        value: jsonValue
      };
    } else {
      return {
        __typename: 'com.hubspot.chirp.ext.models.DoubleFieldValue',
        value: jsonValue
      };
    }
  }
  if (type === 'boolean') {
    return {
      __typename: 'com.hubspot.chirp.ext.models.BooleanFieldValue',
      value: jsonValue
    };
  }
  if (Array.isArray(jsonValue)) {
    return {
      __typename: 'com.hubspot.chirp.ext.models.ListFieldValue',
      value: jsonValue.map(item => convertJsonToFieldValueAvro(item))
    };
  }
  if (type === 'object') {
    const avroObject = {};
    const objValue = jsonValue;
    for (const key in objValue) {
      if (Object.prototype.hasOwnProperty.call(objValue, key)) {
        avroObject[key] = convertJsonToFieldValueAvro(objValue[key]);
      }
    }
    return {
      __typename: 'com.hubspot.chirp.ext.models.MapFieldValue',
      value: avroObject
    };
  }

  // Default fallback for unsupported types
  return {
    __typename: 'com.hubspot.chirp.ext.models.NullFieldValue'
  };
}

/**
 * Converts from FieldValue Avro format to plain JSON format
 */
export function convertFieldValueAvroToJson(avroValue) {
  if (!avroValue || typeof avroValue !== 'object' || !('__typename' in avroValue)) {
    return null;
  }
  const typedValue = avroValue;
  switch (typedValue.__typename) {
    case 'com.hubspot.chirp.ext.models.NullFieldValue':
      return null;
    case 'com.hubspot.chirp.ext.models.StringFieldValue':
    case 'com.hubspot.chirp.ext.models.IntFieldValue':
    case 'com.hubspot.chirp.ext.models.LongFieldValue':
    case 'com.hubspot.chirp.ext.models.DoubleFieldValue':
    case 'com.hubspot.chirp.ext.models.FloatFieldValue':
    case 'com.hubspot.chirp.ext.models.BooleanFieldValue':
      return typedValue.value;
    case 'com.hubspot.chirp.ext.models.ListFieldValue':
      {
        const listValue = typedValue;
        return listValue.value.map(item => convertFieldValueAvroToJson(item));
      }
    case 'com.hubspot.chirp.ext.models.MapFieldValue':
      {
        const jsonObject = {};
        const mapValue = typedValue.value;
        for (const key in mapValue) {
          if (Object.prototype.hasOwnProperty.call(mapValue, key)) {
            jsonObject[key] = convertFieldValueAvroToJson(mapValue[key]);
          }
        }
        return jsonObject;
      }
    default:
      {
        const __exhaustiveCheck = typedValue;
        return null;
      }
  }
}